export default __webpack_public_path__ + "static/media/totem.530bd08e.svg";